import { redColor } from 'pages/Logs/components/LogTable.styled';
import styled from 'styled-components';
import { mobileRes } from '../LFHeader/LFHeader.styled';
import { overlayContentZIndex, overlayZIndex } from '../Modal/Modal.styled';

export const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${overlayZIndex};
  pointer-events: none;
`;

export const Bg = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100svh;
  opacity: 0;
  background: black;
  z-index: ${overlayZIndex};
  pointer-events: none;
  transition: all ease-out 150ms;
`;

export const BookingCont = styled.div`
  height: 100%;
  width: calc(100vw - 95px);
  background: white;
  position: fixed;
  right: -750px;
  top: 0px;
  z-index: ${overlayContentZIndex};
  transition: all ease-out 250ms;
  max-width: 650px;
  box-sizing: border-box;
  /* Space above panel headers (Escape sits in this band) for every right modal */
  padding-top: 25px;
  overflow-x: hidden;
  overscroll-behavior-x: none;
  /* Inner modal Container owns vertical scroll — avoid nested y scrollports */
  overflow-y: hidden;
  @media(max-width: ${mobileRes}) {
    width: calc(100vw - 15px);
  }
`;

export const Escape = styled.div`
  /* Absolute so Escape does not add flow height (that forced a second y scroll) */
  position: absolute;
  color: grey;
  right: 10px;
  z-index: 3;
  top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    border-color: ${redColor};
    color: ${redColor};
  }
`;

export const Bg2 = styled(Bg)`
  z-index: ${overlayZIndex + 1};
`;

export const BookingCont2 = styled(BookingCont)`
  z-index: ${overlayContentZIndex + 1};
  width: calc(100% - 60px);
`;
